import React from "react";

import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import * as Yup from "yup";

import { CreateAndDetailLayout } from "../../../components/CreateAndDetailLayout";
import { GroupInput } from "../../../components/Form/GroupInput";
import { Input } from "../../../components/Form/Input";
import { LayoutForm } from "../../../components/Form/LayoutForm";
import { Select } from "../../../components/Form/Select";
import { PanelAndDetailAndCreateHeader } from "../../../components/panel/PanelAndDetailAndCreateHeader";
import api from "../../../service/api";
import { ButtunSubmit, ContainerForm } from "../styles";

const CreateUser: React.FC = () => {
  const { addToast } = useToasts();
  const history = useHistory();

  async function handleSubmit(create: any) {
    try {
      console.log(create);
      await api.post("/requirement", {
        value: create.value,
        description: create.description,
        is_active: Boolean(Number(create.is_active)),
      });

      addToast("Requisitos criado com sucesso", {
        appearance: "success",
        autoDismiss: true,
      });
      history.push("/requisitos");
    } catch (error: any) {
      if (!error.response) {
        return addToast(
          "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }

      return addToast(
        "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  }

  const formik = useFormik({
    initialValues: {
      value: undefined,
      description: undefined,
      is_active: 1,
    },
    validationSchema: Yup.object({
      value: Yup.string().required("Valor é obrigatório"),
      description: Yup.string().required("Descrição é obrigatório"),
    }),
    onSubmit: (data) => handleSubmit(data),
  });
  return (
    <CreateAndDetailLayout>
      <PanelAndDetailAndCreateHeader title={"Criar Requisito"} goBack />
      <ContainerForm>
        <LayoutForm onSubmit={formik.handleSubmit}>
          <GroupInput>
            <Input
              label="Descrição"
              {...formik.getFieldProps("description")}
              error={
                formik.touched.description && formik.errors.description
                  ? formik.errors.description
                  : undefined
              }
            />

            <Select
              data={[
                { name: "Sim", value: "1" },
                { name: "Não", value: "0" },
              ]}
              label="Ativo"
              {...formik.getFieldProps("is_active")}
              error={
                formik.touched.is_active && formik.errors.is_active
                  ? formik.errors.is_active
                  : undefined
              }
            />
          </GroupInput>

          <Input
            label="Valor"
            {...formik.getFieldProps("value")}
            error={
              formik.touched.value && formik.errors.value
                ? formik.errors.value
                : undefined
            }
          />

          <ButtunSubmit type="submit"> Criar </ButtunSubmit>
        </LayoutForm>
      </ContainerForm>
    </CreateAndDetailLayout>
  );
};

export default CreateUser;
